import {
    EnumPaymentMethod,
    paymentMethodOptions,
    type ApiTransaction,
    type EnumInvoiceType,
    type EnumProcessState,
    type EnumTaxationMode,
} from '@Model';
import {
    DivWithSpacing,
    Grid,
    GridColumn,
    GridColumns,
    NumberInput,
    Select,
    TextInput,
    useAutoConfirmed,
    useGuiBinder,
    useProp,
    useTranslate,
    type ISubFrameBodyProps,
    type Nullable,
    DateInput,
} from '@synqo/frontend-component-library';
import { formatIban } from '../../../formatters';

interface InvoiceRefProps {
    priceDisplay: EnumTaxationMode;
    processState: EnumProcessState;
    invoiceType: EnumInvoiceType;
}

export function FrameInvoiceTransaction(props: ISubFrameBodyProps<ApiTransaction> & InvoiceRefProps) {
    const i18n = useTranslate('');

    const binder = useGuiBinder<ApiTransaction>(props);

    const dateField = useProp(binder, 'date');
    const amountField = useProp<ApiTransaction, number>(binder, 'amount');
    const paymentMethodField = useAutoConfirmed<ApiTransaction, Nullable<EnumPaymentMethod>>(binder, 'payment_method');
    const ibanField = useProp(binder, 'iban', undefined, formatIban);
    const bicField = useProp(binder, 'bic');
    const accountHolderField = useProp(binder, 'account_holder');
    const remarksField = useProp(binder, 'remarks');

    return (
        <DivWithSpacing padding={{ left: 'xxl', right: 'lg', top: 'md', bottom: 'md' }} className={'w-4/5'}>
            <Grid columns={12}>
                <GridColumns spans={[4, 4, 4]}>
                    <DateInput type="day" {...dateField} label={i18n('Zahlungsdatum')} />
                    <NumberInput {...amountField} decimals={2} label={i18n('Betrag')} />
                    <Select<Nullable<EnumPaymentMethod>>
                        key="payment_method"
                        items={paymentMethodOptions}
                        {...paymentMethodField}
                        label={i18n('Zahlungsart')}
                        clearable
                    />
                    <TextInput {...ibanField} label={i18n('IBAN')} />
                    <TextInput {...bicField} label={i18n('BIC')} />
                    <TextInput {...accountHolderField} label={i18n('Kontoinhaber')} />
                </GridColumns>
                <GridColumn span={12}>
                    <TextInput {...remarksField} label={i18n('Bemerkung')} inputSize={2} />
                </GridColumn>
            </Grid>
        </DivWithSpacing>
    );
}
